"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _PieSynConnectorIcon = _interopRequireDefault(require("ecosystem-marketplace-core/components/common/PieSynConnectorIcon"));

var PieSyncConnectorIcon = function PieSyncConnectorIcon(props) {
  var linkComponent = props.linkComponent,
      rest = (0, _objectWithoutProperties2.default)(props, ["linkComponent"]);
  return _react.default.createElement(_PieSynConnectorIcon.default, (0, _extends2.default)({}, rest, {
    linkComponent: linkComponent,
    linkProps: {
      to: '/_detail/piesync'
    }
  }));
};

PieSyncConnectorIcon.propTypes = {
  linkComponent: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.func])
};
PieSyncConnectorIcon.defaultProps = {
  linkComponent: _UIRouterLink.default
};
var _default = PieSyncConnectorIcon;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/PieSyncConnectorIcon.js
// module id = 268
// module chunks = 209 210 211 212